export const isTextAd = (ad) => ad._type === 'Ads/TextAd';
export const isProductAd = (ad) => ad._type === 'Ads/ProductAd';
